export default "__VITE_ASSET__E5ncP0st__"